import {RecordLocatorFacility, RecordLocatorFacilityConnected} from "@shared-library";

export class RecordLocatorResponse {
  pending_patient_accounts: { [key: string]: RecordLocatorFacility } = {}
  discovered_patient_accounts: { [key: string]: RecordLocatorFacility } = {}
  connected_patient_accounts: { [key: string]: RecordLocatorFacilityConnected } = {}
}
